<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container.px-6
    div.heading-5.basic700--text {{ $t('send_email_to_customer') }}
    div.text-md.font-normal.basic700--text {{ $t('send_email_to_customer_desc') }}
    v-divider.my-6

    v-row(no-gutters)
      v-col(cols="12" sm="8" md="6")
        yc-text-field.mt-3(v-model="eventName" :label="$t('event_name')")
        v-text-field.text-md.round-xl.mt-3(v-model="subject" :placeholder="$t('type_something')" :prefix="`${$t('subject')}:`" outlined hide-details)
        page-editor.mt-3.mx-(v-if="showFroala" :parentForm.sync="content")

        v-btn.button-md.mt-8.mb-10(color="info500" :dark="!disabledSend" depressed :disabled="disabledSend" @click="openSendEmailDialog = true") {{ $t('send') }}

  .modals
    send-email-dialog(v-if="openSendEmailDialog" :open.sync="openSendEmailDialog" :eventName="eventName" :subject="subject" :content="content" :donors="selectedCustomers" @redirect="closeRedirect" type="customers")

</template>

<script>
import { mapGetters } from 'vuex'
import SendEmailDialog from '@/components/donation/dialogs/SendEmailDialog.vue'
import PageEditor from '@/components/donation/PageEditor.vue'

export default {
  components: { SendEmailDialog, PageEditor },
  data () {
    return {
      currentTab: 0,
      breadcrumbItems: [
        {
          text: this.$t('customers'),
          disabled: false,
          href: '/admin/connect/customers'
        },
        {
          text: this.$t('send_email'),
          disabled: true
        }
      ],
      subject: null,
      content: null,
      eventName: null,
      openSendEmailDialog: false,
      showFroala: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      selectedCustomers: 'customers/getSelectedCustomers'
    }),
    disabledSend () {
      if (this.subject && this.content && this.eventName) {
        return false
      }
      return true
    }
  },
  mounted () {
    if (!this.selectedCustomers.length) {
      this.$router.push('/admin/connect/customers')
    }
    this.$nextTick(() => {
      this.showFroala = true
    })
  },
  methods: {
    closeRedirect () {
      this.$router.push('/admin/connect/customers')
    }
  },
  destroyed () {
    this.$store.commit('customers/resetSelectedCustomers')
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>